export function changeSidebarButtonState(activeButton, actionType) {
    return (function (dispatch) {
      dispatch({
        type: actionType,
        payload: activeButton
      });
    });
    
   }
